// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wLoWP69oEugrm2 {
  box-sizing: border-box;
  width: 248px;
  height: 144px;
  padding: 8px 12px;
  overflow: hidden;
  border: none;
  border-radius: 8px;
  background-color: var(--ds-background-brand-bold, #0c66e4);
  background-image: none;
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--ds-text, #172b4d);
}
.wLoWP69oEugrm2.G79utiTGPVda9_ {
  background-color: var(--ds-background-neutral, #091e420f);
}
.wLoWP69oEugrm2 .gkOioFX2awcPBO,
.wLoWP69oEugrm2 .nC4iF6PEIiAh_C,
.wLoWP69oEugrm2 .YZdootrZ4XObhw {
  color: inherit;
}
.wLoWP69oEugrm2 .SAFJz3SYdI0em_ {
  opacity: 1;
}
.G79utiTGPVda9_ .SAFJz3SYdI0em_,
.gDXCoJxFUGwBuk .SAFJz3SYdI0em_ {
  opacity: 0;
}
.G79utiTGPVda9_ .VwpRVKid__L5Vf,
.gDXCoJxFUGwBuk .VwpRVKid__L5Vf {
  background-color: var(--ds-background-neutral, #091e420f);
}
.gkOioFX2awcPBO {
  margin: 0;
  overflow: hidden;
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gkOioFX2awcPBO ~ .L6KCJ5zV3WqrAR {
  margin-top: 16px;
}
.gkOioFX2awcPBO ~ .nC4iF6PEIiAh_C {
  margin-top: 4px;
}
.L6KCJ5zV3WqrAR {
  white-space: nowrap;
}
.L6KCJ5zV3WqrAR .VwpRVKid__L5Vf {
  display: inline-block;
  margin-right: 8px;
  vertical-align: top;
}
.L6KCJ5zV3WqrAR .VwpRVKid__L5Vf:last-child {
  margin-right: 0;
}
.nC4iF6PEIiAh_C {
  margin: 0;
  overflow: hidden;
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, normal);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.YZdootrZ4XObhw {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}
.SAFJz3SYdI0em_ {
  box-sizing: border-box;
  height: 20px;
  border-radius: 4px;
  opacity: 0.8;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: 0px 1px 1px var(--ds-border, #091e4224), 0px 0px 1px var(--ds-border, #091e4224);
}
.VwpRVKid__L5Vf {
  box-sizing: border-box;
  width: calc(20% - 6px);
  padding: 4px 4px 16px;
  border-radius: 6px;
  background-color: var(--ds-surface-sunken, #f7f8f9);
}
.VwpRVKid__L5Vf .SAFJz3SYdI0em_ {
  margin-bottom: 4px;
}
.VwpRVKid__L5Vf .SAFJz3SYdI0em_:last-child {
  margin-bottom: 0;
}
.pyFTQcX4Q1BiPz {
  display: block;
  width: 112px;
  height: 8px;
  margin-bottom: 16px;
  border-radius: 100px;
  background-color: var(--ds-surface, #ffffff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"board": `wLoWP69oEugrm2`,
	"boardError": `G79utiTGPVda9_`,
	"boardName": `gkOioFX2awcPBO`,
	"teamName": `nC4iF6PEIiAh_C`,
	"errorMessage": `YZdootrZ4XObhw`,
	"card": `SAFJz3SYdI0em_`,
	"boardLoading": `gDXCoJxFUGwBuk`,
	"list": `VwpRVKid__L5Vf`,
	"boardLists": `L6KCJ5zV3WqrAR`,
	"placeholderTopBar": `pyFTQcX4Q1BiPz`
};
export default ___CSS_LOADER_EXPORT___;
